import React, { FC, useEffect, useState } from 'react'
import { ToastContainer } from 'react-toastify'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useNavigate } from 'react-router-dom'
import clsx from 'clsx'
import {
  fetchData,
  getEncryptedRoute,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
} from '../../../../reusable'
import { KTIcon } from '../../../../_metronic/helpers'
import { Tr } from '../../../../_metronic/i18n/Tr'

const AddRoles: FC = () => {
    let t = Tr()
  const { urlData, menuId } = useMenuIdPermissions()
  const roleId = urlData?.roleId
  const [loading, setLoading] = useState(false)
  const [menuList, setMenuList] = useState([])
  const navigate = useNavigate()

  const initialValues = {
    roleId: '',
    role: '',
    menuIdAdd: [] as string[],
    menuIdEdit: [] as string[],
    menuIdDelete: [] as string[],
    menuIdView: ['1'] as string[],
  }

  const roleValidationSchema = Yup.object().shape({
    role: Yup.string()
      .trim()
      .required('Role Name is required')
      .max(100, 'Maximum 100 characters allowed'),
  })

  // save roles and rights
  const formik: any = useFormik({
    initialValues,
    validationSchema: roleValidationSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      const adminData = JSON.parse(sessionStorage.getItem('admin') || '{}')
      const adminId = adminData.adminId

      try {
        const param: any = {
          roleName: values.role,
          roleId: values.roleId,
          menuIdAdd: values.menuIdAdd.join(','),
          menuIdEdit: values.menuIdEdit.join(','),
          menuIdDelete: values.menuIdDelete.join(','),
          menuIdView: values.menuIdView.join(','),
          adminId: adminId,
        }
        var response: any = await fetchData('admin/addeditrole', param)

        if (String(response?.status) == '200') {
          setSubmitting(false)
          toastsuccessmsg(response.message)
          setLoading(false)
          setTimeout(() => {
            navigate(
              getEncryptedRoute("../viewroles", { menuId: menuId })
            )
          }, 1000)
        } else {
          setLoading(false)
          setSubmitting(false)
          toasterrormsg(response.message)
        }
      } catch (error) {
        setStatus('Details are incorrect')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  // menu list api call
  const menuListApiCall = async () => {
    // var param: any = {
    //   roleId: getEncodedCookie("roleId"),
    // };
    var response: any = await fetchData('admin/menu', {})

    if (String(response?.status) == '200') {
      var data = response.data
      setMenuList(data)
    } else {
      toasterrormsg(response.data.message)
    }
  }

  const roleDetailApiCall = async () => {
    var param: any = {
      roleId: roleId,
    }
    var response: any = await fetchData('admin/viewrole', param)

    if (String(response?.status) == '200') {
      var data = response.data[0]

      formik.setFieldValue('menuIdView', data.menuIdView ? data.menuIdView.split(',') : [])
      formik.setFieldValue('menuIdDelete', data.menuIdDelete ? data.menuIdDelete.split(',') : [])
      formik.setFieldValue('menuIdEdit', data.menuIdEdit ? data.menuIdEdit.split(',') : [])
      formik.setFieldValue('menuIdAdd', data.menuIdAdd ? data.menuIdAdd.split(',') : [])
      formik.setFieldValue('role', data.roleName)
      formik.setFieldValue('roleId', data.roleId)
    } else {
      toasterrormsg(response.data.message)
    }
  }

  useEffect(() => {
    menuListApiCall()
  }, [])

  useEffect(() => {
    if (roleId) {
      roleDetailApiCall()
    }
  }, [roleId])



  const handleCheckboxChange = (
    menuId: string,
    action: string,
    isSubmenu: boolean = false,
    parentMenuId: string = '',
    childMenuIds: string[] = []
  ) => {
    const key = `menuId${capitalize(action)}`
    const currentList = formik.values[key] as string[]

    let updatedList = [...currentList]
    const isChecked = currentList.includes(menuId)

    if (isChecked) {
      // ❌ Uncheck: Remove this menuId and its parentMenuId (if present)
      updatedList = updatedList.filter(id => id !== menuId && id !== parentMenuId)

      // Also remove children if it's a parent menu
      if (!isSubmenu && childMenuIds.length > 0) {
        updatedList = updatedList.filter(id => !childMenuIds.includes(id))
      }

    } else {
      // ✅ Check: Add this menuId
      updatedList.push(menuId)

      // If it's a submenu, ensure parent is also added
      if (isSubmenu && parentMenuId) {
        updatedList.push(parentMenuId)
      }

      // If it's a parent menu, add all its children
      if (!isSubmenu && childMenuIds.length > 0) {
        updatedList = [...updatedList, ...childMenuIds]
      }

      // Deduplicate
      updatedList = [...new Set(updatedList)]
    }

    formik.setFieldValue(key, updatedList)
  }

  const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1)

  const getAllMenuIdsWithPermission = (action: string) => {
    const collectIds = (items: any[]): string[] => {
      let ids: string[] = []

      items.forEach((item) => {
        // if (item[action] == 1) {
        ids.push(item.menuId)
        // }

        if (Array.isArray(item.submenu)) {
          ids = ids.concat(collectIds(item.submenu))
        }
      })

      return ids
    }

    return collectIds(menuList)
  }

  const isViewAction = (action: string) => action === 'view'

  const handleActionSelectAll = (action: string, checked: boolean) => {
    const ids = getAllMenuIdsWithPermission(action)
    formik.setFieldValue(
      `menuId${capitalize(action)}`,
      checked
        ? isViewAction(action)
          ? ['1', ...ids.filter((id) => id !== '1')]
          : ids
        : isViewAction(action)
          ? ['1']
          : []
    )
  }


  const handleMenuPermissionToggle = (
    menuItem: any,
    checked: boolean,
    parentMenuId: string = ''
  ) => {
    ;['view', 'edit', 'delete', 'add'].forEach((action) => {
      if (menuItem[action] == 1) {
        const key = `menuId${capitalize(action)}`
        const current = formik.values[key]

        let updated = checked
          ? [...new Set([...current, menuItem.menuId])]
          : current.filter(
            (id: string) => id !== menuItem.menuId || (isViewAction(action) && id === '1')
          )

        // ✅ Always remove parentMenuId if unchecked
        if (!checked && parentMenuId) {
          updated = updated.filter((id: string) => id !== parentMenuId)
        }

        // ✅ Always add parentMenuId if checked
        if (checked && parentMenuId) {
          updated = [...new Set([...updated, parentMenuId])]
        }

        formik.setFieldValue(key, updated)
      }
    })
  }

  const renderMenuRow = (
    menuItem: any,
    parentMenuId: string = '',
    level: number = 0
  ): React.ReactNode => {
    const hasSubmenus = Array.isArray(menuItem.submenu) && menuItem.submenu.length > 0

    const permittedActions = ['view', 'edit', 'delete', 'add'].filter(
      (action) => menuItem[action] == 1
    )
    const isChecked =
      permittedActions.length > 0 &&
      permittedActions.every((action) =>
        formik.values[`menuId${capitalize(action)}`].includes(menuItem.menuId)
      )

    // Optional color and indentation
    const levelColors = ['#ffffff', '#f8f9fa', '#f1f3f5', '#e9ecef']
    const backgroundColor = levelColors[level] || '#dee2e6'
    const borderLeft = level > 0 ? `4px solid #adb5bd` : 'none'

    // ✅ RENDER GROUP TITLE (like "Listing Management", "Master")
    if (menuItem.isGroupTitle) {
      return (
        <tr key={menuItem.menuId}>
          <td
            colSpan={5}
            style={{
              backgroundColor: '#f1f3f5',
              fontWeight: 'bold',
              padding: '12px 16px',
              borderTop: '1px solid #dee2e6',
              borderBottom: '1px solid #dee2e6',
              fontSize: '15px',
            }}
          >
            {menuItem.name}
          </td>
        </tr>
      )
    }

    // ✅ RENDER NORMAL MENU ROW
    return (
      <React.Fragment key={menuItem.menuId}>
        <tr
          style={{
            backgroundColor,
            borderLeft,
          }}
          className='border'
        >
          <td
            className='fw-bold text-start align-items-center d-flex'
            style={{
              paddingLeft: `${level ? level * 24 : '10'}px`,
              border: '1px solid #dee2e6',
            }}
          >
            {/* ✅ Show checkbox only if no submenus */}
            {!hasSubmenus && (
              <div className='bg-white rounded d-inline-block  me-2'>
                <input
                  type='checkbox'
                  disabled={menuItem.menuId == '1' ? true : false}
                  className='form-check-input border-2'
                  checked={isChecked}
                  onChange={(e) =>
                    menuItem.menuId != '1'
                      ? handleMenuPermissionToggle(menuItem, e.target.checked, parentMenuId)
                      : ''
                  }
                />
              </div>
            )}
            <span className='d-flex align-items-center'>
              {level > 0 && <KTIcon iconName='black-right' className='fs-4 me-2 text-muted' />}
              {menuItem.name}
            </span>
          </td>

          {['view', 'edit', 'delete', 'add'].map((action) => {
            const hasPermission = menuItem[action] == 1
            return (
              <td
                key={`${menuItem.menuId}-${action}`}
                className='fw-bold align-middle text-center'
                style={{ border: '1px solid #dee2e6' }}
              >
                {hasPermission ? (
                  <div className='bg-white rounded d-inline-block'>
                    <input
                      type='checkbox'
                      disabled={menuItem.menuId == '1' ? true : false}
                      className='form-check-input border-2'
                      checked={formik.values[`menuId${capitalize(action)}`].includes(
                        menuItem.menuId
                      )}
                      onChange={() =>
                        menuItem.menuId != '1'
                          ? handleCheckboxChange(
                            menuItem.menuId,
                            action,
                            !!parentMenuId,
                            parentMenuId
                          )
                          : ''
                      }
                    />
                  </div>
                ) : null}
              </td>
            )
          })}
        </tr>

        {hasSubmenus &&
          menuItem.submenu.map((subItem: any) =>
            renderMenuRow(subItem, menuItem.menuId, level + 1)
          )}
      </React.Fragment>
    )
  }

  return (
    <>
      <ToastContainer />
      <div className='card mb-5 mb-xl-10 mt-4'>
        <div className='card-header border-0 cursor-pointer'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'> {roleId ? t('Edit') : t('Add')} {t("Role")}</h3>
          </div>
        </div>

        <div id='kt_account_profile_details' className='collapse show'>
          <form onSubmit={formik.handleSubmit} noValidate className='form'>
            <div className='card-body border-top p-9'>
              <div className='row'>
                <div className='col-lg-4'>
                  <label className=' col-form-label required fw-bold fs-6'>{t("Role Name")}</label>

                  <div className='fv-row'>
                    <input
                      type='text'
                      id='role'
                      name='role'
                      placeholder={t('Role Name')}
                      className={clsx(
                        `form-control`,
                        {
                          'is-invalid': formik.touched.role && formik.errors.role,
                        },
                        {
                          'is-valid': formik.touched.role && !formik.errors.role,
                        }
                      )}
                      value={formik.values.role}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.role && formik.errors.role && (
                      <div className='fv-plugins-message-container'>
                        <span role='alert' className='text-danger'>
                          {formik.errors.role}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className='row mt-12'>
                <div className='col-lg-12'>
                  <div className='row mb-5'>
                    <div className='col-lg-12'>
                      <label className='form-label fs-6 fw-bolder text-gray-900 required'>
                        {t("Menu Rights")}
                      </label>

                      <div className='' style={{ minWidth: '100%', overflowX: 'auto' }}>
                        <table className='table table-bordered align-middle text-center'>
                          <thead
                            className='bg-secondary rounded'
                            style={{
                              border: '1px solid lightgray',
                            }}
                          >
                            <tr>
                              <th>{t("Menu Name")}</th>
                              {['view', 'edit', 'delete', 'add'].map((action) => (
                                <th key={action} className='text-center fw-bold align-middle'>
                                  <div className='d-inline-flex align-items-center justify-content-center gap-2'>
                                    <div className='fw-bolder'>{t(capitalize(action))}</div>
                                    <div className='bg-light rounded'>
                                      <input
                                        type='checkbox'
                                        className='form-check-input border-2 '
                                        onChange={(e) =>
                                          handleActionSelectAll(action, e.target.checked)
                                        }
                                        // checked={getAllMenuIdsWithPermission(action).every((id) =>
                                        //   formik.values[`menuId${capitalize(action)}`].includes(id)
                                        // )}
                                        checked={
                                          getAllMenuIdsWithPermission(action).length > 0 &&
                                          getAllMenuIdsWithPermission(action).every((id) =>
                                            formik.values[`menuId${capitalize(action)}`].includes(
                                              id
                                            )
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>{menuList.map((menuItem: any) => renderMenuRow(menuItem))}</tbody>
                        </table>
                      </div>

                      {formik.touched.deductionAccess && formik.errors.deductionAccess && (
                        <div className='fv-plugins-message-container'>
                          <span role='alert' className='text-danger'>
                            {formik.errors.deductionAccess}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='card-footer d-flex justify-content-end py-6 px-9'>
              <button type='submit' className='btn btn-success' disabled={formik.isSubmitting}>
                {!loading && t('Save')}
                {loading && (
                  <span className='indicator-progress' style={{ display: 'block' }}>
                    {t("Please wait...")}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              <button
                id='kt_password_cancel'
                type='button'
                className='btn bg-secondary btn-active-light-primary px-6 py-3 mx-3'
              >
                {t("Cancel")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export { AddRoles }
